export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./payment-system.vue?vue&type=template&id=5d703603&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/payment-system.vue?vue&type=template&id=5d703603&scoped=true
// module id = Qg/4
// module chunks = 0